<div class="d-flex flex-row gap-2">
    @if (showGpsData() && lastSeenBySatelliteMessage() != '?') {
        <div class="{{ lastSeenBySatelliteMessageColorClass() }} text-nowrap color-secondary-information">
            <i class="fa-solid fa-location-dot {{ lastSeenBySatelliteMessageColorClass() }}"></i>
            {{ lastSeenBySatelliteMessage() }}
        </div>
    }
  @if (nfcScanMoments().length > 0) {
    <div>| Last scanned: {{timeAgo(nfcScanMoments().at(nfcScanMoments().length-1)?.scannedAt)}}</div>
  }
</div>
